module.exports = __webpack_public_path__ + "img/Logo_FacilImmo_300.d9cafd9e.jpg";